import React from 'react';
import OrderInfo from './dashboard/OrderInfo';
import OrderedItems from './dashboard/OrderedItems';
import { Sale, Dealer, Order } from '../../../backend/shared/types';

type DashboardProps = {
  sale: Sale;
  dealer: Dealer;
  order: Order;
}

const Dashboard = (props: DashboardProps) => {
  const { sale, dealer, order } = props;
  return (
    <>
      <OrderInfo sale={sale} dealer={dealer} order={order} />
      <OrderedItems sale={sale} order={order} />
    </>
  );
};

export default Dashboard;